<app-enfaf-modal
  [title]="'COURSE.BLOCKED.TITLE' | translate"
  [subtitle]="'COURSE.BLOCKED.BODY' | translate"
  [ngStyleTitle]="{ 'padding-bottom': '24px' }"
  svgIcon="alert-triangle-dark"
  [showContent]="false"
  [showCancelButton]="false"
  [buttonConfirmText]="'COURSE.BLOCKED.ACTION' | translate"
  (onConfirm)="goToProfile()"
></app-enfaf-modal>
